// components/Orders/UpdateOrderStatusModal.js
import OrderStatusBadge from "components/Common/OrderStatusBadge";
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Spinner } from "reactstrap";
import { orderApiService } from "services/orderApiService";

const UpdateOrderStatusModal = ({ isOpen, toggle, order, onUpdateSuccess }) => {
  const [status, setStatus] = useState(order?.orderstatus || "");
  const [paymentStatus, setPaymentStatus] = useState(order?.paymentstatus || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!status && !paymentStatus) return;

    setLoading(true);
    setError(null);

    try {
      await orderApiService.updateOrderStatus(order.id, { orderstatus: status, paymentstatus: paymentStatus, });
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
      toggle();
    } catch (error) {
      setError("Failed to update status. Please try again.");
      console.error("Failed to update status:", error);
    } finally {
      setLoading(false);
    }
  };

  const statusOptions = [
    { value: "submitted", label: "Submitted" },
    // { value: "processing", label: "Processing" },
    // { value: "completed", label: "Completed" },
    { value: "Delivered", label: "Delivered" },
    { value: "Cancelled", label: "Cancelled" },
    // { value: "pending", label: "Pending" },
  ];

  const paymentStatusOptions = [
    { value: "paid", label: "Paid" },
    { value: "unpaid", label: "Unpaid" }
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Update Order Status
        <div className="mt-1">
          <small className="text-muted">Order #{order?.id}</small>
        </div>
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="status">Select Order Status</Label>
          <select
            className="form-select"
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            disabled={loading}
          >
            <option value="">Select Status</option>
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </FormGroup>

        <FormGroup>
          <Label for="paymentStatus">Select Payment Status</Label>
          <select
            className="form-select"
            id="paymentStatus"
            value={paymentStatus}
            onChange={(e) => setPaymentStatus(e.target.value)}
            disabled={loading}
          >
            <option value="">Select Status</option>
            {paymentStatusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </FormGroup>

        {/* {order && (
          <div className="mt-3">
            <h6>Current Status: <OrderStatusBadge status={order.orderstatus} /></h6>
          </div>
        )} */}

        {error && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !status || !paymentStatus}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Updating...
            </>
          ) : "Update Status"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateOrderStatusModal;